<div>
  <div class="container text-center mt-4 mb-2">
    <img src="./assets/images/logo-ust.svg" alt="logo" class="img-fluid" style="height: 120px; cursor: pointer"
      (click)="returnToLogin()" />
  </div>
</div>
<div style="background-color:#114B43; height:900px">
  <div class="container pt-4 pb-4">
    <fieldset style="background: #eee !important;">

      <form [formGroup]="ContactForm" novalidate>
        <div class="container" style="background: #9cb93f;">
          <br>
          <h2 class="titlex">Creación de una cuenta de usuario</h2>
          <h5 class="titlex mb-2">Ingresa tus datos para crear una cuenta y acceder a Matrícula Online</h5>
        </div>

        <div class="alert alert-warning mt-3 ml-3 mr-3" role="alert" *ngIf="mensajes?.showEnListaEspera">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <label class="alert-heading">Estimado Postulante:</label>
          <p>Usted está en lista de espera si quiere más información contactar a la Universidad</p>
          <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-primary" class="btn btn-primary mt-3"
              style="background-color: #114B43!important; border-color:#114B43;" (click)="returnToLogin()">
              Ir al inicio
            </button>
          </div>
        </div>

        <div class="alert alert-warning mt-3 ml-3 mr-3" role="alert" *ngIf="mensajes?.showSelecciondo">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <label class="alert-heading">Estimado Postulante:</label>
          <p>Para realizar su matrícula debe hacerla de forma presencial en nuestras instalaciones</p>
          <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-primary" class="btn btn-primary mt-3"
              style="background-color: #114B43!important; border-color:#114B43;" (click)="returnToLogin()">
              Ir al inicio
            </button>
          </div>
        </div>

        <div class="form">
          <label class="ml-3">Los campos con (*) son obligatorios</label>
          <div class="row mt-2 container">
            <h4 class="font-weight-bold ml-3" style="color: black;">Datos personales</h4>
          </div>
          <div class="row mt-2 container">
            <div class="col-md-12">
              <div class="form-group row">
                <div class="col-sm-6">
                  <label>Tipo de documento</label>
                  <div class="d-flex justify-content-start">
                    <input id="true" type="radio" value='1' name="Nacionalidad" formControlName="Nacionalidad">
                    <label class="custom-control-label" for="true">RUT</label>
                    <input id="false" type="radio" value='2' name="Nacionalidad" formControlName="Nacionalidad">
                    <label class="custom-control-label" for="false">Pasaporte</label>
                  </div>
                </div>
                <div class="col-sm-6" *ngIf="ContactForm.controls.Nacionalidad.value=='1'">
                  <label>Rut <span class="text-danger">*</span></label>
                  <input type="text" formatRut autocomplete="false" class="form-control form-control-sm"
                    placeholder="Ingresa tu RUT con guión y sin puntos" formControlName="RUT" id="txtRut"
                    (click)="clearRut()">
                  <span class="text-muted"
                    *ngIf="(!ContactForm.controls.RUT.valid && ContactForm.controls.RUT?.touched)">Por
                    favor, ingrese un RUT válido</span>
                </div>
                <div class="col-sm-6" *ngIf="ContactForm.controls.Nacionalidad.value=='2'">
                  <label>Pasaporte <span class="text-danger">*</span></label>
                  <input type="text" class="form-control form-control-sm" formControlName="Pasaporte"
                    placeholder="Ingresa tu Pasaporte" formControlName="Pasaporte" id="Pasaporte"
                    (click)="clearPasaporte()">
                  <span class="text-muted"
                    *ngIf="(!ContactForm.controls.Pasaporte.valid && ContactForm.controls.Pasaporte?.touched)">Por
                    favor, ingrese un Pasaporte válido</span>
                </div>
              </div>
            </div>
          </div>

          <div class="row container mt-2">
            <div class="col-md-12">
              <re-captcha (resolved)="resolved($event)" siteKey="6LcvntYZAAAAAD7vJSrZr18NQr-anQiVSDFWRRWd"
                formControlName="Captcha">
              </re-captcha>
              <span class="text-muted"
                *ngIf="!ContactForm.controls['Captcha'].valid && ContactForm.controls['Captcha']?.touched">
                Debe verificar el captcha</span>
            </div>
          </div>

          <div class="row container mt-2">
            <div class="col-md-12">

              <div class="progress" id="progress" *ngIf="progress">
                <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar"
                  aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
              </div>

              <div class="alert alert-success alert-dismissible fade show mt-2 lg-success" role="alert"
                *ngIf="mensajes.showSuccess">
                {{ mensajes.mensaje }}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="alert alert-danger alert-dismissible fade show mt-2 lg-danger" role="alert"
                *ngIf="mensajes.showError">
                {{ mensajes.mensaje }}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
          </div>
          <div class="row container mt-2">
            <div class="col-md-12">
              <app-apibutton text="Solicitar acceso al registro" [progress]="progressValidacion"
                (click)="validateEmailDemre()">
              </app-apibutton>
            </div>
          </div>
          <div class="row text-center container mt-2 mb-4">
            <div class="col-md-12">
              <a class="text-white mt-1 btn btn-primary btn-block" href="/login"
                style="cursor:pointer; background-color: #000000;">Volver</a>
            </div>
          </div>
        </div>
      </form>
    </fieldset>
    <!-- {{ ContactForm.value | json }} -->
  </div>
</div>
